document.addEventListener('DOMContentLoaded', function () {
  initProductSliders(document);
});

// Falls du im Theme Editor arbeitest: neu initialisieren, wenn eine Section geladen wird
document.addEventListener('shopify:section:load', function (event) {
  initProductSliders(event.target);
});

function initProductSliders(context) {
  // NUR normale Product Slider, NICHT unsere Custom-Image-Slider
  const containers = context.querySelectorAll(
    '.product-slider:not(.product-slider--custom-images) .product-slider__swiper'
  );

  containers.forEach(function (container) {
    // Wenn Swiper schon drauf ist, nicht nochmal initialisieren
    if (container.classList.contains('swiper-initialized')) return;

    const paginationEl = container.querySelector(
      '.swiper-pagination.product-slider__swiper-pagination'
    );

    new Swiper(container, {
      loop: false,
      spaceBetween: 6,
      slidesPerView: 1.3,
      centeredSlides: false,
      pagination: {
        el: paginationEl,
        type: 'progressbar',
      },
      grabCursor: true,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
      },
      watchOverflow: true,
      breakpoints: {
        500: {
          slidesPerView: 1.5,
          spaceBetween: 10,
        },
        600: {
          slidesPerView: 1.9,
          spaceBetween: 10,
        },
        800: {
          slidesPerView: 2.25,
          spaceBetween: 10,
        },
        900: {
          slidesPerView: 2.75,
          slidesOffsetAfter: 16,
          spaceBetween: 8,
        },
        1100: {
          slidesPerView: 3.25,
          slidesOffsetAfter: 16,
          spaceBetween: 8,
        },
        1200: {
          slidesPerView: 4.1,
          slidesOffsetAfter: 16,
          spaceBetween: 8,
        },
        1600: {
          slidesPerView: 4.9,
          slidesOffsetAfter: 16,
          spaceBetween: 8,
        },
      },
    });
  });
}